import apiClient from '../lib/apiClient'

/**
 * AWS Polly speech for the player. Each call returns an audio URL (read-through
 * cached on the backend) plus the resolved voice. Gated to the new interface on
 * the backend, so these are only ever called from GameScreen2 / its chat.
 */
export const speechService = {
  /**
   * Synthesize one segment of a story beat. The backend resolves narrator vs.
   * responding-character voice from the beat and segment index. `segment_count`
   * is the total number of segments the beat splits into (a narration beat can
   * split into narrator + per-character voice segments).
   * @returns {Promise<{url, voice_id, voice_label, cached, segment_count}>}
   */
  async speakBeatSegment(sessionId, beatId, segmentIndex = 0) {
    const response = await apiClient.post(`/api/player_sessions/${sessionId}/speak`, {
      beat_id: beatId,
      segment_index: segmentIndex,
    })
    return response.data.data
  },

  /**
   * Synthesize a single character message from the chat sidebar.
   * @returns {Promise<{url, voice_id, voice_label, cached}>}
   */
  async speakChatMessage(storyId, characterId, text) {
    const response = await apiClient.post('/api/speech/chat', {
      story_id: storyId,
      character_id: characterId,
      text,
    })
    return response.data.data
  },
}
